<h1 mat-dialog-title>Formulario para crear etiqueta</h1>

<mat-dialog-content>
  <span
    class="tw-flex tw-w-full tw-bg-yellow-300 tw-p-3 tw-my-3"
    *ngIf="isStockType"
  >
    Esta etiqueta será marcada como STOCK. La work order no tiene una Sales
    Order asignada
  </span>
  <form [formGroup]="form" (submit)="onSave()">
    <span *ngIf="!isStockType && salesOrderTitle">
      <mat-slide-toggle formControlName="addSalesOrder"
        >Agregar sales order</mat-slide-toggle
      >
      <mat-form-field
        appearance="outline"
        *ngIf="!isStockType && form.get('addSalesOrder')?.value"
      >
        <mat-label>Sales Order</mat-label>
        <input matInput type="text" disabled="true" [value]="salesOrderTitle" />
        <mat-hint>Este valor no se puede modificar</mat-hint>
      </mat-form-field>
    </span>
    <mat-form-field appearance="outline">
      <mat-label>Número de etiquetas</mat-label>
      <input matInput type="number" formControlName="numLabels" />
      <mat-hint>Se refiere a cuántas etiquetas deseas imprimir</mat-hint>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Cantidad</mat-label>
      <input matInput type="number" formControlName="quantity" />
      <mat-hint>Máximo: {{ maxQuantity }}</mat-hint>
    </mat-form-field>
    <mat-form-field *ngIf="showLotNumber" appearance="outline" class="tw-my-2">
      <mat-label>Números de Lote</mat-label>
      <mat-select formControlName="lotNumber">
        <mat-option *ngFor="let lot of lots" [value]="lot">{{
          lot
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="data.destinations?.length" class="tw-mb-3">
      <p class="tw-text-sm tw-font-medium tw-text-gray-600 tw-mb-1">Destino</p>
      <p *ngFor="let dest of data.destinations" class="tw-text-sm tw-font-semibold">{{ dest }}</p>
    </div>

    <mat-form-field appearance="fill">
      <mat-label>Estaciones de Impresión</mat-label>
      <mat-select formControlName="printer">
        <mat-option
          *ngFor="let printer of printers"
          [value]="generatePrinterName(printer.printerName, printer.department)"
        >
          {{ generatePrinterName(printer.printerName, printer.department) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container [ngTemplateOutlet]="templateForm"> </ng-container>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button class="app-btn-close" mat-raised-button mat-dialog-close>
    Cancelar
  </button>
  <button
    mat-raised-button
    [disabled]="form.invalid"
    [class.app-btn-save]="form.valid"
    (click)="onSave()"
  >
    Guardar
  </button>
</mat-dialog-actions>
